import { render, staticRenderFns } from "./Parlement.vue?vue&type=template&id=18ed8eea&"
import script from "./Parlement.vue?vue&type=script&lang=js&"
export * from "./Parlement.vue?vue&type=script&lang=js&"
import style0 from "./Parlement.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports